export default {
  // Header
  userConfigAndData: 'Configuración y datos del usuario',

  // Botones de imagen
  changeProfilePhoto: 'Cambiar Foto de Perfil',
  selectProfilePhoto: 'Seleccionar Foto de Perfil',
  updatePassword: 'Actualizar Contraseña',

  // Secciones
  personalInformation: 'Información Personal',
  personalInformationSubtitle: 'Datos básicos del usuario',
  contactInformation: 'Información de Contacto',
  contactInformationSubtitle: 'Datos de contacto',
  platformLanguage: 'Idioma de la Plataforma',
  platformLanguageSubtitle: 'Selecciona el idioma de la interfaz',

  // Campos de información personal
  lastName: 'Apellidos',
  lastNamePlaceholder: 'Ingrese apellidos',
  firstName: 'Nombres',
  firstNamePlaceholder: 'Ingrese nombres',
  identifierType: 'Tipo de Identificador',
  identifier: 'Identificador',
  identifierPlaceholder: 'Ingrese identificador',
  gender: 'Género',
  birthDate: 'Fecha de Nacimiento',
  selectDate: 'Seleccione una fecha',

  // Género
  male: 'Masculino',
  female: 'Femenino',
  other: 'Otro',

  // Contacto
  email: 'Correo Electrónico',
  emailPlaceholder: 'correo@ejemplo.com',

  // Idiomas
  spanish: 'Español',
  english: 'English',

  // Botones
  saveChanges: 'Guardar Cambios',
  savePassword: 'Guardar Contraseña',

  // Modal de contraseña
  updatePasswordTitle: 'Actualizar Contraseña',
  currentPassword: 'Contraseña actual',
  currentPasswordPlaceholder: 'Ingrese su contraseña actual',
  currentPasswordRequired: 'Debe ingresar su contraseña actual.',
  newPassword: 'Nueva Contraseña',
  newPasswordPlaceholder: 'Ingrese nueva contraseña',
  newPasswordTooltip: 'Se recomienda utilizar una combinación de mayúsculas, minúsculas, números y símbolos para mayor seguridad.',
  confirmPassword: 'Confirmar Contraseña',
  confirmPasswordPlaceholder: 'Confirme nueva contraseña',
  passwordMismatch: 'Las contraseñas no coinciden.',
  incorrectPassword: 'La contraseña actual es incorrecta.',

  // Modal de imagen
  selectImageTitle: 'Seleccionar Imagen',

  // Mensajes de éxito
  profileCreated: 'Perfil creado.',
  profileUpdated: 'Perfil actualizado.',
  passwordUpdatedSuccess: 'Contraseña actualizada con éxito.',
  languageChangedToSpanish: 'Idioma cambiado a Español',
  languageChangedToEnglish: 'Language changed to English',
  userUpdated: 'Usuario actualizado.',

  // UseCardView tabs
  profileTab: 'Perfil',
  activityTab: 'Actividad',

  // UserLogsView
  activityLog: 'Registro de Actividad',
  activityLogSubtitle: 'Historial de tus cambios en la plataforma',
  searchModelPlaceholder: 'Buscar por modelo...',

  // StudentCard específico
  completeStudentFile: 'Ficha completa del estudiante',
  studentPersonalInformationSubtitle: 'Datos básicos del estudiante',
  changeImage: 'Cambiar Imagen',
  rut: 'RUT',
  rutPlaceholder: '12.345.678-9',
  institutionalInformation: 'Información Institucional',
  academicData: 'Datos académicos',
  entryYear: 'Año de Ingreso',
  selectCorrectYear: 'Seleccione un año correcto.',
  incompleteAdmissionProfile: 'Perfil de Ingreso Incompleto',
  admissionProfileNotCompleted: 'Todavía no ha completado su Perfil de Ingreso. Complete la información requerida.',
  completeAdmissionProfile: 'Completar Perfil de Ingreso',
}
